import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LabelOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"label_off"}/>
}
